import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ControleConductiviteGroup } from 'src/app/domain/Shared/controle-conductivite-groupe';
import { EMasterSondeType } from 'src/app/domain/Shared/enum/master-sonde-type';
import { EpH } from 'src/app/domain/Shared/enum/pH';
import { MasterSonde } from 'src/app/domain/Shared/master-sonde';
import { MasterSondeService } from 'src/app/services/master-sonde.service';
import { StringConverter } from '../string-converter';
import { EConductivite } from 'src/app/domain/Shared/enum/conductivite';

@Component({
    selector: 'app-history-box',
    templateUrl: './history-box.component.html',
    styleUrls: ['./history-box.component.scss']
})
export class HistoryBoxComponent implements OnInit {
    EMasterSondeType = EMasterSondeType
    Model: MasterSonde
    OxygeneColumns: string[] = ['date', 'operateur', 'saturation', 'pression', 'pente', 'conforme'];
    ConductiviteColumns: string[] = ['date', 'operateur', 'valeurMesureC1413', 'valeurCibleC1413', 'temperatureC1413', 'conformeC1413', 'valeurMesureC84', 'valeurCibleC84', 'temperatureC84', 'conformeC84'];
    ConductiviteAjustageColumns: string[] = ['type', 'numeroLot', 'dateOuverture', 'valeurMesuree', 'valeurCible', 'temperature', 'conforme']
    pHGroupControleColumns: string[] = ['date', 'operateur', 'type', 'controleNumeroLot', 'temp', 'valeurCible', 'valeurLue', 'conforme']
    pHAjustageColumns: string[] = ['type', 'numeroLot', 'pente', 'decalage', 'controleNumeroLot', 'temperature', 'valeurCible', 'valeurLue', 'conforme']

    ControleConductiviteGroupeList: ControleConductiviteGroup[] = []
    SearchDate: Date = new Date()
    Reference: string = ''

    SelectedAjustageNumber: number = 0;

    constructor(
        private sondeService: MasterSondeService,
        private dialogRef: MatDialogRef<HistoryBoxComponent>,
        @Inject(MAT_DIALOG_DATA) public data) {
        if (data) {
            this.Reference = data;
            this.getSondeDetails()
        }
    }

    ngOnInit(): void {

    }

    getPhLabel(type: EpH) {
        return StringConverter.getPhName(type);
    }

    getConductiviteLabel(type: EConductivite) {
        return StringConverter.getConductiviteName(type);
    }

    SetSelectedAjustage(i: number) {
        this.SelectedAjustageNumber = i
    }

    getSondeDetails() {
        this.sondeService.getSondeHistoryByReference(this.Reference, this.SearchDate).subscribe(x => {
            this.Model = x;

            if (this.Model.Type === EMasterSondeType.Conductivite) {
                // le context actif en cours
                // this.Model.AjustageContexteList[0].ControleConductiviteGroupeList
                console.log(this.Model)
            }
        })
    }

    onCancel(): void {
        this.dialogRef.close();
    }

}
